'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { FilterToggleGroupSection } from './filter-toggle-group-section.component';

import {
  SearchFilterDayTimeMap,
  SearchFilterDayTimeType,
  searchFilterDayTimeOptions,
} from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-day-time.type';

const options = searchFilterDayTimeOptions.map((value) => ({ value, label: SearchFilterDayTimeMap[value] }));

export const dayTimeOptionTestId = (value: SearchFilterDayTimeType): string =>
  `${DataTestIdEnum.SEARCH_FILTERS_DAY_TIME_OPTION}-${value}`;

interface DayTimeFilterSectionProps {
  value: SearchFilterDayTimeType;
  onChange: (value: SearchFilterDayTimeType) => void;
}

export function DayTimeFilterSection({ value, onChange }: DayTimeFilterSectionProps) {
  return (
    <FilterToggleGroupSection
      label="Período do dia"
      value={value}
      options={options}
      onChange={onChange}
      testId={DataTestIdEnum.SEARCH_FILTERS_DAY_TIME}
      getOptionTestId={dayTimeOptionTestId}
    />
  );
}
